<template>
	<svg
		width="12px"
		height="12px"
		viewBox="0 0 12 12"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="end meeting icon"
	>
		<g
			id="Meetings"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
			stroke-linecap="round"
		>
			<g
				id="End-Meeting"
				transform="translate(-630.000000, -445.000000)"
				stroke="#FFFFFF"
				stroke-width="2.61119983"
			>
				<g id="Group-37" transform="translate(533.000000, 323.000000)">
					<g id="Group-36" transform="translate(57.000000, 109.000000)">
						<g id="Group-34" transform="translate(1.000000, 0.000000)">
							<g id="Group-32" transform="translate(41.000000, 10.000000)">
								<path d="M8,5 L0,13 M0,5 L8,13" id="Combined-Shape" />
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	Name: 'EndMeeting',
}
</script>
<style lang="scss" scoped></style>
